import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Flex } from '@chakra-ui/react'
import { useLabels } from '../../utils/hooks/useLabels/useLabels'
import FormFactory from './FormFactory/FormFactory'
import useButtonSelector from '../../utils/hooks/useButtonSelector/useButtonSelector'
import ButtonSelectorList from '../../components/ButtonSelectorList/ButtonSelectorList'
import { rechargeFormOptionsGenerator } from './functions/formFunctions'

function RechargeForm({ formType, handleSelected }) {
  const { texts } = useLabels()
  const options = rechargeFormOptionsGenerator(texts, formType)
  const { selected, onSelectedChange } = useButtonSelector(options)

  useEffect(() => {
    handleSelected?.(selected)
  }, [selected])
  return (
    <Flex direction="column" mt="45px">
      <Box>
        <ButtonSelectorList
          options={options}
          onSelectedChange={onSelectedChange}
          selected={selected}
        />
      </Box>
      <Box mt="45px">
        <FormFactory context={formType} type={selected?.component} />
      </Box>
    </Flex>
  )
}

RechargeForm.propTypes = {
  formType: PropTypes.string,
  handleSelected: PropTypes.func,
}

export default RechargeForm
